const handleFocusForwards = (
  HTMLFocusableElements: HTMLElement[],
  currentActiveElementIndex: number,
): void => {
  if (currentActiveElementIndex < HTMLFocusableElements.length - 1) {
    return HTMLFocusableElements[currentActiveElementIndex + 1].focus()
  }
  return HTMLFocusableElements[0].focus()
}

export default handleFocusForwards
